module.exports = __webpack_public_path__ + "static/media/logoRound.847375dd.png";